<script>
export default {
  methods: {},
  props: ["value"],
  data: function () {
    return {};
  },
  computed: {},
};
</script>
    
<template>
  <div class="f-value">
    <div class="f-center">
      <div class="f-label">
        <slot name="label"></slot>
      </div>

      <div class="f-the-value">
        <slot name="value"></slot>
      </div>
    </div>
    <div class="f-bottom">
      <div class="f-helper">
        <slot name="helper"></slot>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.f-value {
  width: 100%;
  display: flex;
  flex-direction: column;

  .f-center {
    display: flex;
    .f-label {
      margin-left: 4px;
      display: flex;
      gap: 7px;
      font-weight: 600;
      font-size: 12px;
      line-height: 14px;
      align-items: center;
    }

    .f-the-value {
      display: flex;
      gap: 7px;
      margin-left: auto;
      font-weight: 500;
      font-family: Lato;
      font-size: 12px;
    }
  }
  .f-bottom {
    .f-helper {
      display: flex;
      gap: 7px;
      font-family: Lato;
      margin-top: 6px;
      margin-left: 4px;
      font-size: 12px;
      font-family: Lato;
      color: #161615;
    }
  }
}
.dark-mode {
  .f-value {
    color: var(--white-a75);
	
	.f-center .f-the-value {
		font-size:14px;
	}

    .f-label {
      font-size: 12px;
    }

    .f-the-value
    {
      font-size: 14px;
    }

    .f-bottom {
      .f-helper {
        color: var(--white-a50);
      }
    }
  }
}
</style>